import React, { useState, useEffect } from 'react';
import MayaLogo from "../assets/maya-comp.png";
import { Dropdown } from "flowbite-react";
import { IoSearch } from "react-icons/io5";
import { RxHamburgerMenu } from "react-icons/rx";
import { RxCross2 } from "react-icons/rx";
import { Link } from "react-router-dom";
import MayaDoc from "../assets/Maya-devi.pdf";
import ap1 from "../assets/ap1.pdf"
import ap2 from "../assets/ap2.pdf"
import ap4 from "../assets/ap4.pdf"
import pci from "../assets/pci.pdf"
import { DropDown } from './DropDown';
import { OurSchoolDropDown } from '../pages/ourschools/OurSchoolDropDown';
import { AdmissionDropDown } from '../pages/admissionpages/AdmissionDropDown';
import feestructure from "../assets/MDU Fee Structure (2025-26).pdf"
import brochure from "../assets/MDU BROCHURE for web.pdf"

const Header = () => {
    const [toggle, setToggle] = useState(false);
    const [isMobile, setIsMobile] = useState(false);

    const handleClick = () => {
        setToggle(!toggle);
    };

    const handleResize = () => {
        if (window.innerWidth < 1280) {
            setIsMobile(true);
        } else {
            setIsMobile(false);
            setToggle(false); // Reset toggle on larger screens
        }
    };

    const handleLinkClick = () => {
        setToggle(false); // Close the menu when a link is clicked
    };


    useEffect(() => {
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <div className='relative z-50'>
            <div className='fixed top-0 w-full flex bg-gradient-to-br from-[#97b8ad] via-[#75998f] to-[#547a71] justify-between md:justify-center shadow-xl gap-[50px] font-opensans '>
                {/* Logo Container */}
                <div className='px-6  flex items-center gap-3'>
                    <img src={MayaLogo} className='w-[250px] md:w-[390px] rounded-md' />
                </div>

                {
                    isMobile && (
                        <div className={`mr-4 md:hidden flex items-center gap-2 cursor-pointer ${toggle === true ? "hidden" : "block"}`}
                            onClick={handleClick}>
                            <RxHamburgerMenu className='w-[25px] h-[25px]' />
                            <p>MENU</p>
                        </div>
                    )
                }

                {
                    isMobile && (
                        <div className={`mr-4 md:hidden flex items-center gap-2 cursor-pointer ${toggle === true ? "block" : "hidden"}`}
                            onClick={handleClick}>
                            <RxCross2 className='w-[25px] h-[25px]' />
                            <p>Close</p>
                        </div>
                    )
                }

                {
                    isMobile && (
                        <div
                            className={`w-full flex flex-col items-center justify-center ${toggle ? "block" : "hidden"} absolute top-[70px] bg-gradient-to-br from-[#97b8ad] via-[#75998f] to-[#547a71] py-3`}
                        >

                            {/* Mobile Specific Row */}
                            <div className="flex flex-row justify-center items-center gap-3 bg-gradient-to-br from-yellow-200 via-yellow-300 to-amber-300 p-3 text-center">
                                <Link
                                    to="/contact-us"
                                    onClick={() => {
                                        window.scrollTo(0, 0);
                                        handleLinkClick();
                                    }}
                                    className="font-semibold text-black transition-all duration-200 hover:text-yellow-600"
                                >
                                    Contact Us
                                </Link>
                                <Link to="http://erp.mdu.edu.in/" onClick={() => {
                                    window.scrollTo(0, 0);
                                    handleLinkClick();
                                }} className="font-semibold transition-all duration-200 hover:text-yellow-300">
                                    Student Login
                                </Link>

                                <Dropdown
                                    label={<span className="font-bold">University Recognitions</span>}
                                    inline
                                    className="bg-gradient-to-br from-[#0e4d38] to-[#0a3328]"
                                >


                                    <Link to="/ukgov" onClick={() => {
                                        window.scrollTo(0, 0);
                                        handleLinkClick();
                                    }} className="transition-all duration-300 hover:text-[#0e4d38] hover:border-b-[3px] hover:border-b-[#0e4d38]">
                                        <Dropdown.Item className='transition-all text-white duration-300 hover:text-[#0e4d38]'>Uttarakhand Gov. Letter</Dropdown.Item>
                                    </Link>


                                    <Link to="/ugc" onClick={() => {
                                        window.scrollTo(0, 0);
                                        handleLinkClick();
                                    }} className="transition-all duration-300 hover:text-[#0e4d38] hover:border-b-[3px] hover:border-b-[#0e4d38]">
                                        <Dropdown.Item className='transition-all text-white duration-300 hover:text-[#0e4d38]'>UGC Letter</Dropdown.Item>
                                    </Link>


                                    <Link to="/pci" onClick={() => {
                                        window.scrollTo(0, 0);
                                        handleLinkClick();
                                    }} className="transition-all duration-300 hover:text-[#0e4d38] hover:border-b-[3px] hover:border-b-[#0e4d38]">
                                        <Dropdown.Item className='transition-all text-white duration-300 hover:text-[#0e4d38]'>PCI Letter</Dropdown.Item>
                                    </Link>

                                    <Link to="/ncte" onClick={() => {
                                        window.scrollTo(0, 0);
                                        handleLinkClick();
                                    }} className="transition-all duration-300 hover:text-[#0e4d38] hover:border-b-[3px] hover:border-b-[#0e4d38]">

                                        <Dropdown.Item className='transition-all text-white duration-300 hover:text-[#0e4d38]'>NCTE Letter</Dropdown.Item>
                                    </Link>



                                </Dropdown>
                                {/* <a
                                    href={MayaDoc}
                                    download="MayaUGCApproval"
                                    target="_blank"
                                    className="font-semibold text-black transition-all duration-200 hover:text-yellow-600"
                                >
                                    UGC 8 Counsil Approval
                                </a> */}
                                <Link
                                    to="https://admission.maya.edu.in/"
                                    onClick={() => {
                                        window.scrollTo(0, 0);
                                        handleLinkClick();
                                    }}
                                    className="font-semibold text-black transition-all duration-200 hover:text-yellow-600"
                                >
                                    Apply Now
                                </Link>
                            </div>


                            <div className='flex flex-col md:flex-row justify-between items-center gap-2 px-4 py-2'>
                                <div className='text-white flex flex-col md:flex-row items-center justify-center md:justify-between gap-5 font-semibold md:text-slate-600'>
                                    <Link to="/" onClick={() => {
                                        window.scrollTo(0, 0);
                                        handleLinkClick();
                                    }} className="transition-all duration-300 hover:text-[#0e4d38] hover:border-b-[3px] hover:border-b-[#0e4d38]">Home</Link>
                                    {/* <Link to="/about-us"  onClick={() => {
                                        window.scrollTo(0, 0);
                                        handleLinkClick();
                                    }} className="transition-all duration-300 hover:text-[#0e4d38] hover:border-b-[3px] hover:border-b-[#0e4d38]">About Us</Link> */}
                                    <Dropdown label="About Us" inline className='bg-gradient-to-br from-[#0e4d38] to-[#0a3328] px-10 py-5 hover:text-[#0e4d38] hover:border-b-[3px] hover:border-b-[#0e4d38]'>
                                        <Link to="/about-us"
                                            onClick={() => {
                                                window.scrollTo(0, 0);
                                                handleLinkClick();
                                            }}>
                                            <Dropdown.Item className='transition-all text-white text-md duration-300 hover:text-[#0e4d38]'>About Us</Dropdown.Item>
                                        </Link>
                                        <Link to="/about-us/mdef"
                                            onClick={() => {
                                                window.scrollTo(0, 0);
                                                handleLinkClick();
                                            }}>
                                            <Dropdown.Item className='transition-all text-white text-md duration-300 hover:text-[#0e4d38]'>Maya Devi Educational Foundation</Dropdown.Item>
                                        </Link>
                                        <Link to="/about-us/presidents-message"
                                            onClick={() => {
                                                window.scrollTo(0, 0);
                                                handleLinkClick();
                                            }}>
                                            <Dropdown.Item className='transition-all text-white text-md duration-300 hover:text-[#0e4d38]'>President's Message</Dropdown.Item>
                                        </Link>
                                        <Link to="/about-us/vp-message"
                                            onClick={() => {
                                                window.scrollTo(0, 0);
                                                handleLinkClick();
                                            }}>
                                            <Dropdown.Item className='transition-all text-white text-md duration-300 hover:text-[#0e4d38]'>Vice President's Message</Dropdown.Item>
                                        </Link>
                                        <Link to="/about-us/vc-message"
                                            onClick={() => {
                                                window.scrollTo(0, 0);
                                                handleLinkClick();
                                            }}>
                                            <Dropdown.Item className='transition-all text-white text-md duration-300 hover:text-[#0e4d38]'>Vice Chancellor's Message</Dropdown.Item>
                                        </Link>
                                        <Link to="/about-us/pvc-message"
                                            onClick={() => {
                                                window.scrollTo(0, 0);
                                                handleLinkClick();
                                            }}>
                                            <Dropdown.Item className='transition-all text-white text-md duration-300 hover:text-[#0e4d38]'>Pro Vice Chancellor's Message</Dropdown.Item>
                                        </Link>
                                    </Dropdown>
                                    <Dropdown label="Programmes" inline className='bg-gradient-to-br from-[#0e4d38] to-[#0a3328]'>
                                        <Link to="programmes/diploma-courses"
                                            onClick={() => {
                                                window.scrollTo(0, 0);
                                                handleLinkClick();
                                            }}>
                                            <Dropdown.Item className='transition-all text-white duration-300 hover:text-[#0e4d38]'>Diploma Courses</Dropdown.Item>
                                        </Link>
                                        <Link to="/programmes/ug-courses"
                                            onClick={() => {
                                                window.scrollTo(0, 0);
                                                handleLinkClick();
                                            }}>
                                            <Dropdown.Item className='transition-all text-white duration-300 hover:text-[#0e4d38]'>Undergraduate Course</Dropdown.Item>
                                        </Link>
                                        <Link to="/programmes/pg-courses"
                                            onClick={() => {
                                                window.scrollTo(0, 0);
                                                handleLinkClick();
                                            }}>
                                            <Dropdown.Item className='transition-all text-white duration-300 hover:text-[#0e4d38]'>Post-Graduate Courses</Dropdown.Item>
                                        </Link>
                                        <Link to="/programmes/best-university-for-phd-in-dehradun-uttarakhand"
                                            onClick={() => {
                                                window.scrollTo(0, 0);
                                                handleLinkClick();
                                            }}>
                                            <Dropdown.Item className='transition-all text-white duration-300 hover:text-[#0e4d38]'>Ph.D in all School Programmes</Dropdown.Item>
                                        </Link>
                                    </Dropdown>

                                    <Dropdown
                                        label="Our Schools"
                                        inline
                                        className='bg-gradient-to-br from-[#0e4d38] to-[#0a3328] px-10 py-5'
                                        style={{
                                            maxHeight: isMobile ? '60vh' : '400px',
                                            overflowY: 'auto',
                                            zIndex: 1000,
                                            scrollbarWidth: 'thin',
                                            scrollbarColor: '#0e4d38 transparent'
                                        }}
                                    >
                                        <div className="schools-dropdown-content" style={{
                                            maxHeight: isMobile ? '45vh' : '400px',
                                            overflowY: 'auto',
                                            paddingRight: '8px',
                                        }}>
                                            <Link to="/programmes/ug-courses/best-computer-engineering-college-in-dehradun-uttarakhand"
                                                onClick={() => {
                                                    window.scrollTo(0, 0);
                                                    handleLinkClick();
                                                }}>
                                                <Dropdown.Item className='transition-all text-white duration-300 hover:text-[#0e4d38] text-left whitespace-normal'>School of Computer Engineering & Applications</Dropdown.Item>
                                            </Link>


                                            <Link to="/programmes/ug-courses/best-engineering-college-in-dehradun-uttarakhand"
                                                onClick={() => {
                                                    window.scrollTo(0, 0);
                                                    handleLinkClick();
                                                }}>
                                                <Dropdown.Item className='transition-all text-white duration-300 hover:text-[#0e4d38]'>School of Engineering</Dropdown.Item>
                                            </Link>
                                            <Link to="/programmes/ug-courses/pharmacy"
                                                onClick={() => {
                                                    window.scrollTo(0, 0);
                                                    handleLinkClick();
                                                }}>
                                                <Dropdown.Item className='transition-all text-white duration-300 hover:text-[#0e4d38]'>School of Pharmacy</Dropdown.Item>
                                            </Link>
                                            <Link to="/programmes/ug-courses/management-and-commerce"
                                                onClick={() => {
                                                    window.scrollTo(0, 0);
                                                    handleLinkClick();
                                                }}>
                                                <Dropdown.Item className='transition-all text-white duration-300 hover:text-[#0e4d38]'>School of Commerce & Management</Dropdown.Item>
                                            </Link>
                                            <Link to="/programmes/ug-courses/hotel-management-and-tourism"
                                                onClick={() => {
                                                    window.scrollTo(0, 0);
                                                    handleLinkClick();
                                                }}>
                                                <Dropdown.Item className='transition-all text-white duration-300 hover:text-[#0e4d38]'>School of Hotel Management & Tourism</Dropdown.Item>
                                            </Link>
                                            <Link to="/programmes/ug-courses/sciences"
                                                onClick={() => {
                                                    window.scrollTo(0, 0);
                                                    handleLinkClick();
                                                }}>
                                                <Dropdown.Item className='transition-all text-white duration-300 hover:text-[#0e4d38]'>School of  Life & Applied sciences</Dropdown.Item>
                                            </Link>
                                            <Link to="/programmes/School-Of-Education"
                                                onClick={() => {
                                                    window.scrollTo(0, 0);
                                                    handleLinkClick();
                                                }}>
                                                <Dropdown.Item className='transition-all text-white duration-300 hover:text-[#0e4d38]'>School of Education</Dropdown.Item>
                                            </Link>
                                            <Link to="/programmes/ug-courses/agriculture"
                                                onClick={() => {
                                                    window.scrollTo(0, 0);
                                                    handleLinkClick();
                                                }}>
                                                <Dropdown.Item className='transition-all text-white duration-300 hover:text-[#0e4d38]'>School of Agriculture & Technology</Dropdown.Item>
                                            </Link>
                                            <Link to="/programmes/Nursing"
                                                onClick={() => {
                                                    window.scrollTo(0, 0);
                                                    handleLinkClick();
                                                }}>
                                                <Dropdown.Item className='transition-all text-white duration-300 hover:text-[#0e4d38]'>School of Nursing</Dropdown.Item>
                                            </Link>
                                            {/* <Link to="/programmes/School-Of-Animation-and-Computer-Applications"
                                                onClick={() => {
                                                    window.scrollTo(0, 0);
                                                    handleLinkClick();
                                                }}>
                                                <Dropdown.Item className='transition-all text-white duration-300 hover:text-[#0e4d38]'>School of Animation and Computer Applications</Dropdown.Item>
                                            </Link> */}

                                            {/* <Link to="/programmes/School-Of-Design-and-Lifestyle-Management"
                                                onClick={() => {
                                                    window.scrollTo(0, 0);
                                                    handleLinkClick();
                                                }}>
                                                <Dropdown.Item className='transition-all text-white duration-300 hover:text-[#0e4d38]'>School of Design and Lifestyle Management</Dropdown.Item>
                                            </Link> */}
                                            <Link to="/api"
                                                onClick={() => {
                                                    window.scrollTo(0, 0);
                                                    handleLinkClick();
                                                }}>
                                                <Dropdown.Item className='transition-all text-white duration-300 hover:text-[#0e4d38]'>School of Health Sciences</Dropdown.Item>
                                            </Link>
                                            {/* <Link to="/programmes/School-Of-Journalism-and-Mass-Communication"
                                                onClick={() => {
                                                    window.scrollTo(0, 0);
                                                    handleLinkClick();
                                                }}>
                                                <Dropdown.Item className='transition-all text-white duration-300 hover:text-[#0e4d38]'>School of Journalism and Mass Communication</Dropdown.Item>
                                            </Link> */}

                                            {/* <Link to="/programmes/School-Of-Hospital-Administration"
                                                onClick={() => {
                                                    window.scrollTo(0, 0);
                                                    handleLinkClick();
                                                }}>
                                                <Dropdown.Item className='transition-all text-white duration-300 hover:text-[#0e4d38]'>School of Hospital Administration</Dropdown.Item>
                                            </Link> */}


                                            <Link to="/programmes/School-Of-Paramedical-Sciences"
                                                onClick={() => {
                                                    window.scrollTo(0, 0);
                                                    handleLinkClick();
                                                }}>
                                                <Dropdown.Item className='transition-all text-white duration-300 hover:text-[#0e4d38]'>School of Paramedical Sciences</Dropdown.Item>
                                            </Link>
                                            <Link to="/programmes/ugcourses/Arts-and-humanities/"
                                                onClick={() => {
                                                    window.scrollTo(0, 0);
                                                    handleLinkClick();
                                                }}>
                                                <Dropdown.Item className='transition-all text-white duration-300 hover:text-[#0e4d38]'>School of Arts & Humanities</Dropdown.Item>
                                            </Link>
                                            <Link to="/programmes/School-Of-LegalStudies"
                                                onClick={() => {
                                                    window.scrollTo(0, 0);
                                                    handleLinkClick();
                                                }}>
                                                <Dropdown.Item className='transition-all text-white duration-300 hover:text-[#0e4d38]'>School of Law & Legal Studies</Dropdown.Item>
                                            </Link>
                                            <Link to="/api"
                                                onClick={() => {
                                                    window.scrollTo(0, 0);
                                                    handleLinkClick();
                                                }}>
                                                <Dropdown.Item className='transition-all text-white duration-300 hover:text-[#0e4d38]'>Ashtavakra School Of Rehabilitation</Dropdown.Item>
                                            </Link>
                                            <Link to="/api/programs"
                                                onClick={() => {
                                                    window.scrollTo(0, 0);
                                                    handleLinkClick();
                                                }}>
                                                <Dropdown.Item className='transition-all text-white duration-300 hover:text-[#0e4d38] text-left whitespace-normal'>School of Skill Development & Vocational Studies</Dropdown.Item>
                                            </Link>
                                        </div>
                                    </Dropdown>

                                    <Dropdown label="Admission" inline className='bg-gradient-to-br from-[#0e4d38] to-[#0a3328]'>
                                        <a href={brochure}
                                            download="MDU BROCHURE for web.pdf"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            <Dropdown.Item className='transition-all text-white text-md duration-300 hover:text-[#0e4d38]'>
                                                MDU Brochure
                                            </Dropdown.Item>
                                        </a>
                                        <a href={feestructure}
                                            download="MDU Fee Structure (2025-26).pdf"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            <Dropdown.Item className='transition-all text-white text-md duration-300 hover:text-[#0e4d38]'>
                                                Fee Structure (2025-26)
                                            </Dropdown.Item>
                                        </a>
                                        <Link to="https://admission.maya.edu.in/ "
                                            onClick={() => {
                                                window.scrollTo(0, 0);
                                                handleLinkClick();
                                            }}>
                                            <Dropdown.Item className='transition-all text-white duration-300 hover:text-[#0e4d38]'>Apply Now</Dropdown.Item>
                                        </Link>
                                        <Link to="/admission/infrastructure"
                                            onClick={() => {
                                                window.scrollTo(0, 0);
                                                handleLinkClick();
                                            }}>
                                            <Dropdown.Item className='transition-all text-white duration-300 hover:text-[#0e4d38]'>Campus Life</Dropdown.Item>
                                        </Link>
                                        <Link to="/api"
                                            onClick={() => {
                                                window.scrollTo(0, 0);
                                                handleLinkClick();
                                            }}>
                                            <Dropdown.Item className='transition-all text-white duration-300 hover:text-[#0e4d38]'>Hostel Fees</Dropdown.Item>
                                        </Link>
                                        <Link to="/api"
                                            onClick={() => {
                                                window.scrollTo(0, 0);
                                                handleLinkClick();
                                            }}>
                                            <Dropdown.Item className='transition-all text-white duration-300 hover:text-[#0e4d38]'>Download Brochure</Dropdown.Item>
                                        </Link>
                                        <Link to="/api"
                                            onClick={() => {
                                                window.scrollTo(0, 0);
                                                handleLinkClick();
                                            }}>
                                            <Dropdown.Item className='transition-all text-white duration-300 hover:text-[#0e4d38]'>List of Holidays</Dropdown.Item>
                                        </Link>
                                        <Link to="/api"
                                            onClick={() => {
                                                window.scrollTo(0, 0);
                                                handleLinkClick();
                                            }}>
                                            <Dropdown.Item className='transition-all text-white duration-300 hover:text-[#0e4d38]'>Academic Calender</Dropdown.Item>
                                        </Link>
                                        <Link to="/apply-now"
                                            onClick={() => {
                                                window.scrollTo(0, 0);
                                                handleLinkClick();
                                            }}>
                                            <Dropdown.Item className='transition-all text-white duration-300 hover:text-[#0e4d38]'>Quick Enquiry Form</Dropdown.Item>
                                        </Link>
                                        {/* <Link to="/admission/scholarships"
                                            onClick={() => {
                                                window.scrollTo(0, 0);
                                                handleLinkClick();
                                            }}>
                                            <Dropdown.Item className='transition-all text-white duration-300 hover:text-[#0e4d38]'>Scholarship</Dropdown.Item>
                                        </Link> */}
                                        {/* <Link to="/admission/eligibility-criteria"
                                            onClick={() => {
                                                window.scrollTo(0, 0);
                                                handleLinkClick();
                                            }}>
                                            <Dropdown.Item className='transition-all text-white duration-300 hover:text-[#0e4d38]'>Eligibility Criteria</Dropdown.Item>
                                        </Link> */}
                                        <Link to="/admission/refund-policy"
                                            onClick={() => {
                                                window.scrollTo(0, 0);
                                                handleLinkClick();
                                            }}>
                                            <Dropdown.Item className='transition-all text-white duration-300 hover:text-[#0e4d38]'>Refund Policy</Dropdown.Item>
                                        </Link>
                                    </Dropdown>

                                    <Link to="/placements" onClick={() => {
                                        window.scrollTo(0, 0);
                                        handleLinkClick();
                                    }} className="transition-all duration-300 hover:text-[#0e4d38] hover:border-b-[3px] hover:border-b-[#0e4d38]">Placement</Link>
                                    <Link to="/maya-in-media" onClick={() => {
                                        window.scrollTo(0, 0);
                                        handleLinkClick();
                                    }} className="transition-all duration-300 hover:text-[#0e4d38] hover:border-b-[3px] hover:border-b-[#0e4d38]">Maya @ Media</Link>
                                </div>
                                <Link to="/career" onClick={() => {
                                    window.scrollTo(0, 0);
                                    handleLinkClick();
                                }} className="text-white font-semibold transition-all duration-300 hover:text-[#0e4d38] hover:border-b-[3px] hover:border-b-[#0e4d38]"> Career</Link>

                                <Link to="https://admission.maya.edu.in/">
                                    <button className='mt-5 md:mt-0 bg-gradient-to-br from-yellow-200 via-yellow-300 to-amber-300  px-4 py-2 text-black rounded-full transition-all duration-200 hover:bg-gradient-to-br from-yellow-200 via-yellow-300 to-amber-300 hover:text-black'>
                                        Apply Now
                                    </button>
                                </Link>

                                <Link
                                    to="https://admission.maya.edu.in/MDUCET/"
                                    onClick={() => {
                                        window.scrollTo(0, 0);
                                    }}
                                    className="relative md:block bg-gradient-to-br from-yellow-200 via-yellow-300 to-amber-300 px-2 py-1 text-black rounded-md font-[500] focus:ring-offset-2
          text-black shadow-md hover:shadow-lg
          transform hover:-translate-y-0.5
          animate-pulse-slow motion-safe:animate-bounce-subtle
          transition-all duration-300"
                                >
                                    <span className="relative z-10 ">Apply for MDU-CET </span>
                                    <div className="absolute inset-0 bg-white opacity-0 group-hover:opacity-10 rounded-lg transition-opacity duration-300"></div>
                                </Link>
                            </div>
                        </div>

                    )
                }

                {
                    !isMobile && (
                        <div className={`w-full flex flex-col gap-2 font-opensans`}>
                            <div className='bg-gradient-to-br from-[#0e4d38] to-[#0a3328] uppercase rounded-bl-lg flex text-sm justify-between items-center gap-5 px-4 py-2 text-white mb-[-10]'>
                                <div className='flex flex-col md:flex-row items-center justify-between gap-5 py-2'>
                                    <Link to="/contact-us" onClick={() => {
                                        window.scrollTo(0, 0);
                                        handleLinkClick();
                                    }} className="font-semibold transition-all duration-200 hover:text-yellow-300">Contact Us</Link>
                                    <Link to="http://erp.mdu.edu.in/" onClick={() => {
                                        window.scrollTo(0, 0);
                                        handleLinkClick();
                                    }} className="font-semibold transition-all duration-200 hover:text-yellow-300">Student Login</Link>
                                    <Dropdown label={<span className="font-bold">UNIVERSITY RECOGNITION</span>} inline className='bg-gradient-to-br from-[#0e4d38] to-[#0a3328] '>
                                        <Link to="/ukgov" onClick={() => {
                                            window.scrollTo(0, 0);
                                            handleLinkClick();
                                        }} className="transition-all duration-300 hover:text-[#0e4d38] hover:border-b-[3px] hover:border-b-[#0e4d38]">
                                            <Dropdown.Item className='transition-all text-white duration-300 hover:text-[#0e4d38]'>Uttarakhand Gov. Letter</Dropdown.Item>
                                        </Link>


                                        <Link to="/ugc" onClick={() => {
                                            window.scrollTo(0, 0);
                                            handleLinkClick();
                                        }} className="transition-all duration-300 hover:text-[#0e4d38] hover:border-b-[3px] hover:border-b-[#0e4d38]">
                                            <Dropdown.Item className='transition-all text-white duration-300 hover:text-[#0e4d38]'>UGC Letter</Dropdown.Item>
                                        </Link>


                                        <Link to="/pci" onClick={() => {
                                            window.scrollTo(0, 0);
                                            handleLinkClick();
                                        }} className="transition-all duration-300 hover:text-[#0e4d38] hover:border-b-[3px] hover:border-b-[#0e4d38]">
                                            <Dropdown.Item className='transition-all text-white duration-300 hover:text-[#0e4d38]'>PCI Letter</Dropdown.Item>
                                        </Link>

                                        <Link to="/ncte" onClick={() => {
                                            window.scrollTo(0, 0);
                                            handleLinkClick();
                                        }} className="transition-all duration-300 hover:text-[#0e4d38] hover:border-b-[3px] hover:border-b-[#0e4d38]">

                                            <Dropdown.Item className='transition-all text-white duration-300 hover:text-[#0e4d38]'>NCTE Letter</Dropdown.Item>
                                        </Link>


                                    </Dropdown>
                                    <Link to="https://admission.maya.edu.in/" onClick={() => {
                                        window.scrollTo(0, 0);
                                        handleLinkClick();
                                    }} className="font-semibold transition-all duration-200 hover:text-yellow-300">Apply Now</Link>
                                    <p className='hidden md:block bg-gradient-to-br from-yellow-200 via-yellow-300 to-amber-300 px-2 py-1 text-black rounded-md font-[500]'>
                                        <a href="tel:0135-2658602">0135-2658602</a>
                                        <span className='ml-2'>For General Query</span>
                                    </p>
                                    <Link
                                        to="https://admission.maya.edu.in/MDUCET/"
                                        onClick={() => {
                                            window.scrollTo(0, 0);
                                        }}
                                        className="relative md:block bg-gradient-to-br from-yellow-200 via-yellow-300 to-amber-300 px-2 py-1 text-black rounded-md font-[500] focus:ring-offset-2
          text-black shadow-md hover:shadow-lg
          transform hover:-translate-y-0.5
          animate-pulse-slow motion-safe:animate-bounce-subtle
          transition-all duration-300"
                                    >
                                        <span className="relative z-10 ">Apply for MDU-CET</span>
                                        <div className="absolute inset-0 bg-white opacity-0 group-hover:opacity-10 rounded-lg transition-opacity duration-300"></div>
                                    </Link>
                                </div>
                                <IoSearch className='hidden md:block text-xl' />
                            </div>

                            <div className="flex justify-between items-center gap-2 px-10 py-3 mt-[-1]">
                                <div className='flex items-center md:justify-between text-md gap-5 font-semibold md:text-slate-600' style={{ color: "#fff" }}>
                                    <Link to="/" onClick={() => {
                                        window.scrollTo(0, 0);
                                        handleLinkClick();
                                    }} className="text-white transition-all duration-300 hover:text-[#0e4d38] hover:border-b-[3px] hover:border-b-[#0e4d38]">Home</Link>
                                    <Dropdown label="About Us" inline className='bg-gradient-to-br from-[#0e4d38] to-[#0a3328] px-10 py-5 hover:text-[#0e4d38] hover:border-b-[3px] hover:border-b-[#0e4d38]'>
                                        <Link to="/about-us" onClick={() => {
                                            window.scrollTo(0, 0);
                                            handleLinkClick();
                                        }}>
                                            <Dropdown.Item className='transition-all text-white text-md duration-300 hover:text-[#0e4d38]'>About Us</Dropdown.Item>
                                        </Link>
                                        <Link to="/about-us/mdef" onClick={() => {
                                            window.scrollTo(0, 0);
                                            handleLinkClick();
                                        }}>
                                            <Dropdown.Item className='transition-all text-white text-md duration-300 hover:text-[#0e4d38]'>Maya Devi Educational Foundation</Dropdown.Item>
                                        </Link>
                                        <Link to="/about-us/presidents-message" onClick={() => {
                                            window.scrollTo(0, 0);
                                            handleLinkClick();
                                        }}>
                                            <Dropdown.Item className='transition-all text-white text-md duration-300 hover:text-[#0e4d38]'>President's Message</Dropdown.Item>
                                        </Link>
                                        <Link to="/about-us/vp-message" onClick={() => {
                                            window.scrollTo(0, 0);
                                            handleLinkClick();
                                        }}>
                                            <Dropdown.Item className='transition-all text-white text-md duration-300 hover:text-[#0e4d38]'>Vice President's Message</Dropdown.Item>
                                        </Link>
                                        <Link to="/about-us/vc-message" onClick={() => {
                                            window.scrollTo(0, 0);
                                            handleLinkClick();
                                        }}>
                                            <Dropdown.Item className='transition-all text-white text-md duration-300 hover:text-[#0e4d38]'>Vice Chancellor's Message</Dropdown.Item>
                                        </Link>
                                        <Link to="/about-us/pvc-message" onClick={() => {
                                            window.scrollTo(0, 0);
                                            handleLinkClick();
                                        }}>
                                            <Dropdown.Item className='transition-all text-white text-md duration-300 hover:text-[#0e4d38]'>Pro Vice Chancellor's Message</Dropdown.Item>
                                        </Link>
                                    </Dropdown>

                                    <Dropdown label="Programmes" inline className='bg-gradient-to-br from-[#0e4d38] to-[#0a3328] px-10 py-5 hover:text-[#0e4d38] hover:border-b-[3px] hover:border-b-[#0e4d38]'>
                                        <Link to="programmes/diploma-courses"
                                            onClick={() => {
                                                window.scrollTo(0, 0);
                                                handleLinkClick();
                                            }}>
                                            <Dropdown.Item className='transition-all text-white text-md duration-300 hover:text-[#0e4d38]'>Diploma Courses</Dropdown.Item>
                                        </Link>
                                        <Link to="/programmes/ug-courses"
                                            onClick={() => {
                                                window.scrollTo(0, 0);
                                                handleLinkClick();
                                            }}>
                                            <Dropdown.Item className='transition-all text-white text-md duration-300 hover:text-[#0e4d38]'>Undergraduate Course</Dropdown.Item>
                                        </Link>
                                        <Link to="/programmes/pg-courses"
                                            onClick={() => {
                                                window.scrollTo(0, 0);
                                                handleLinkClick();
                                            }}>
                                            <Dropdown.Item className='transition-all text-white text-md duration-300 hover:text-[#0e4d38]'>Post-Graduate Courses</Dropdown.Item>
                                        </Link>
                                        <Link to="/programmes/best-university-for-phd-in-dehradun-uttarakhand"
                                            onClick={() => {
                                                window.scrollTo(0, 0);
                                                handleLinkClick();
                                            }}>
                                            <Dropdown.Item className='transition-all text-white text-md duration-300 hover:text-[#0e4d38]'>Ph.D in all School Programmes</Dropdown.Item>
                                        </Link>
                                    </Dropdown>

                                    <Dropdown
                                        label="Our Schools"
                                        inline
                                        className='bg-gradient-to-br from-[#0e4d38] to-[#0a3328] px-10 py-5'
                                        style={{
                                            maxHeight: isMobile ? '60vh' : '400px',
                                            overflowY: 'auto',
                                            zIndex: 1000,
                                            scrollbarWidth: 'thin',
                                            scrollbarColor: '#0e4d38 transparent'
                                        }}
                                    >
                                        <div className="schools-dropdown-content" style={{
                                            maxHeight: isMobile ? '60vh' : '400px',
                                            overflowY: 'auto',
                                            paddingRight: '8px',
                                        }}>
                                            <Link to="/programmes/ug-courses/best-computer-engineering-college-in-dehradun-uttarakhand"
                                                onClick={() => {
                                                    window.scrollTo(0, 0);
                                                    handleLinkClick();
                                                }}>
                                                <Dropdown.Item className='transition-all text-white duration-300 hover:text-[#0e4d38]'>School of Computer Engineering & Applications</Dropdown.Item>
                                            </Link>

                                            <Link to="/programmes/ug-courses/best-engineering-college-in-dehradun-uttarakhand"
                                                onClick={() => {
                                                    window.scrollTo(0, 0);
                                                    handleLinkClick();
                                                }}>
                                                <Dropdown.Item className='transition-all text-white duration-300 hover:text-[#0e4d38]'>School of Engineering</Dropdown.Item>
                                            </Link>
                                            <Link to="/programmes/ug-courses/pharmacy"
                                                onClick={() => {
                                                    window.scrollTo(0, 0);
                                                    handleLinkClick();
                                                }}>
                                                <Dropdown.Item className='transition-all text-white duration-300 hover:text-[#0e4d38]'>School of Pharmacy</Dropdown.Item>
                                            </Link>
                                            <Link to="/programmes/ug-courses/management-and-commerce"
                                                onClick={() => {
                                                    window.scrollTo(0, 0);
                                                    handleLinkClick();
                                                }}>
                                                <Dropdown.Item className='transition-all text-white duration-300 hover:text-[#0e4d38]'>School of Commerce & Management</Dropdown.Item>
                                            </Link>
                                            <Link to="/programmes/ug-courses/hotel-management-and-tourism"
                                                onClick={() => {
                                                    window.scrollTo(0, 0);
                                                    handleLinkClick();
                                                }}>
                                                <Dropdown.Item className='transition-all text-white duration-300 hover:text-[#0e4d38]'>School of Hotel Management & Tourism</Dropdown.Item>
                                            </Link>
                                            <Link to="/programmes/ug-courses/sciences"
                                                onClick={() => {
                                                    window.scrollTo(0, 0);
                                                    handleLinkClick();
                                                }}>
                                                <Dropdown.Item className='transition-all text-white duration-300 hover:text-[#0e4d38]'>School of  Life & Applied sciences</Dropdown.Item>
                                            </Link>
                                            <Link to="/programmes/School-Of-Education"
                                                onClick={() => {
                                                    window.scrollTo(0, 0);
                                                    handleLinkClick();
                                                }}>
                                                <Dropdown.Item className='transition-all text-white duration-300 hover:text-[#0e4d38]'>School of Education</Dropdown.Item>
                                            </Link>
                                            <Link to="/programmes/ug-courses/agriculture"
                                                onClick={() => {
                                                    window.scrollTo(0, 0);
                                                    handleLinkClick();
                                                }}>
                                                <Dropdown.Item className='transition-all text-white duration-300 hover:text-[#0e4d38]'>School of Agriculture & Technology</Dropdown.Item>
                                            </Link>
                                            <Link to="/programmes/Nursing"
                                                onClick={() => {
                                                    window.scrollTo(0, 0);
                                                    handleLinkClick();
                                                }}>
                                                <Dropdown.Item className='transition-all text-white duration-300 hover:text-[#0e4d38]'>School of Nursing</Dropdown.Item>
                                            </Link>
                                            {/* <Link to="/programmes/School-Of-Animation-and-Computer-Applications"
                                                onClick={() => {
                                                    window.scrollTo(0, 0);
                                                    handleLinkClick();
                                                }}>
                                                <Dropdown.Item className='transition-all text-white duration-300 hover:text-[#0e4d38]'>School of Animation and Computer Applications</Dropdown.Item>
                                            </Link> */}

                                            {/* <Link to="/programmes/School-Of-Design-and-Lifestyle-Management"
                                                onClick={() => {
                                                    window.scrollTo(0, 0);
                                                    handleLinkClick();
                                                }}>
                                                <Dropdown.Item className='transition-all text-white duration-300 hover:text-[#0e4d38]'>School of Design and Lifestyle Management</Dropdown.Item>
                                            </Link> */}
                                            <Link to="/api"
                                                onClick={() => {
                                                    window.scrollTo(0, 0);
                                                    handleLinkClick();
                                                }}>
                                                <Dropdown.Item className='transition-all text-white duration-300 hover:text-[#0e4d38]'>School of Health Sciences</Dropdown.Item>
                                            </Link>
                                            {/* <Link to="/programmes/School-Of-Journalism-and-Mass-Communication"
                                                onClick={() => {
                                                    window.scrollTo(0, 0);
                                                    handleLinkClick();
                                                }}>
                                                <Dropdown.Item className='transition-all text-white duration-300 hover:text-[#0e4d38]'>School of Journalism and Mass Communication</Dropdown.Item>
                                            </Link> */}

                                            {/* <Link to="/programmes/School-Of-Hospital-Administration"
                                                onClick={() => {
                                                    window.scrollTo(0, 0);
                                                    handleLinkClick();
                                                }}>
                                                <Dropdown.Item className='transition-all text-white duration-300 hover:text-[#0e4d38]'>School of Hospital Administration</Dropdown.Item>
                                            </Link> */}


                                            <Link to="/programmes/School-Of-Paramedical-Sciences"
                                                onClick={() => {
                                                    window.scrollTo(0, 0);
                                                    handleLinkClick();
                                                }}>
                                                <Dropdown.Item className='transition-all text-white duration-300 hover:text-[#0e4d38]'>School of Paramedical Sciences</Dropdown.Item>
                                            </Link>
                                            <Link to="/programmes/ugcourses/Arts-and-humanities/"
                                                onClick={() => {
                                                    window.scrollTo(0, 0);
                                                    handleLinkClick();
                                                }}>
                                                <Dropdown.Item className='transition-all text-white duration-300 hover:text-[#0e4d38]'>School of Arts & Humanities</Dropdown.Item>
                                            </Link>
                                            <Link to="/programmes/School-Of-LegalStudies"
                                                onClick={() => {
                                                    window.scrollTo(0, 0);
                                                    handleLinkClick();
                                                }}>
                                                <Dropdown.Item className='transition-all text-white duration-300 hover:text-[#0e4d38]'>School of Law & Legal Studies</Dropdown.Item>
                                            </Link>
                                            <Link to="/api"
                                                onClick={() => {
                                                    window.scrollTo(0, 0);
                                                    handleLinkClick();
                                                }}>
                                                <Dropdown.Item className='transition-all text-white duration-300 hover:text-[#0e4d38]'>Ashtavakra School Of Rehabilitation</Dropdown.Item>
                                            </Link>
                                            <Link to="/api/programs"
                                                onClick={() => {
                                                    window.scrollTo(0, 0);
                                                    handleLinkClick();
                                                }}>
                                                <Dropdown.Item className='transition-all text-white duration-300 hover:text-[#0e4d38]'>School of Skill Development & Vocational Studies</Dropdown.Item>
                                            </Link>
                                        </div>
                                    </Dropdown>

                                    <Dropdown label="Admission" inline className='bg-gradient-to-br from-[#0e4d38] to-[#0a3328] px-10 py-5'>
                                        <a href={brochure}
                                            download="MDU BROCHURE for web.pdf"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            <Dropdown.Item className='transition-all text-white text-md duration-300 hover:text-[#0e4d38]'>
                                                MDU Brochure
                                            </Dropdown.Item>
                                        </a>
                                        <a href={feestructure}
                                            download="MDU Fee Structure (2025-26).pdf"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            <Dropdown.Item className='transition-all text-white text-md duration-300 hover:text-[#0e4d38]'>
                                                Fee Structure (2025-26)
                                            </Dropdown.Item>
                                        </a>
                                        <Link to="https://admission.maya.edu.in/ "
                                            onClick={() => {
                                                window.scrollTo(0, 0);
                                                handleLinkClick();
                                            }}>
                                            <Dropdown.Item className='transition-all text-white duration-300 hover:text-[#0e4d38]'>Apply Now</Dropdown.Item>
                                        </Link>
                                        <Link to="/admission/infrastructure"
                                            onClick={() => {
                                                window.scrollTo(0, 0);
                                                handleLinkClick();
                                            }}>
                                            <Dropdown.Item className='transition-all text-white text-md duration-300 hover:text-[#0e4d38]'>Campus Life</Dropdown.Item>
                                        </Link>
                                        <Link to="/api"
                                            onClick={() => {
                                                window.scrollTo(0, 0);
                                                handleLinkClick();
                                            }}>
                                            <Dropdown.Item className='transition-all text-white duration-300 hover:text-[#0e4d38]'>Hostel Fees</Dropdown.Item>
                                        </Link>
                                        <Link to="/api"
                                            onClick={() => {
                                                window.scrollTo(0, 0);
                                                handleLinkClick();
                                            }}>
                                            <Dropdown.Item className='transition-all text-white duration-300 hover:text-[#0e4d38]'>Download Brochure</Dropdown.Item>
                                        </Link>
                                        <Link to="/api"
                                            onClick={() => {
                                                window.scrollTo(0, 0);
                                                handleLinkClick();
                                            }}>
                                            <Dropdown.Item className='transition-all text-white duration-300 hover:text-[#0e4d38]'>List of Holidays</Dropdown.Item>
                                        </Link>
                                        <Link to="/api"
                                            onClick={() => {
                                                window.scrollTo(0, 0);
                                                handleLinkClick();
                                            }}>
                                            <Dropdown.Item className='transition-all text-white duration-300 hover:text-[#0e4d38]'>Academic Calender</Dropdown.Item>
                                        </Link>
                                        <Link to="/apply-now"
                                            onClick={() => {
                                                window.scrollTo(0, 0);
                                                handleLinkClick();
                                            }}>
                                            <Dropdown.Item className='transition-all text-white text-md duration-300 hover:text-[#0e4d38]'>Quick Enquiry Form</Dropdown.Item>
                                        </Link>
                                        {/* <Link to="/admission/scholarships"
                                            onClick={() => {
                                                window.scrollTo(0, 0);
                                                handleLinkClick();
                                            }}>
                                            <Dropdown.Item className='transition-all text-white text-md duration-300 hover:text-[#0e4d38]'>Scholarship</Dropdown.Item>
                                        </Link> */}
                                        {/* <Link to="/admission/eligibility-criteria"
                                            onClick={() => {
                                                window.scrollTo(0, 0);
                                                handleLinkClick();
                                            }}>
                                            <Dropdown.Item className='transition-all text-white text-md duration-300 hover:text-[#0e4d38]'>Eligibility Criteria</Dropdown.Item>
                                        </Link> */}
                                        <Link to="/admission/refund-policy"
                                            onClick={() => {
                                                window.scrollTo(0, 0);
                                                handleLinkClick();
                                            }}>
                                            <Dropdown.Item className='transition-all text-white text-md duration-300 hover:text-[#0e4d38]'>Refund Policy</Dropdown.Item>
                                        </Link>
                                    </Dropdown>

                                    <Link to="/placements" onClick={() => {
                                        window.scrollTo(0, 0);
                                        handleLinkClick();
                                    }} className="text-white transition-all duration-300 hover:text-[#0e4d38] hover:border-b-[3px] hover:border-b-[#0e4d38]">Placement</Link>
                                    <Link to="/maya-in-media" onClick={() => {
                                        window.scrollTo(0, 0);
                                        handleLinkClick();
                                    }} className="text-white transition-all duration-300 hover:text-[#0e4d38] hover:border-b-[3px] hover:border-b-[#0e4d38]">Maya @ Media</Link>
                                    <Link to="/career" onClick={() => {
                                        window.scrollTo(0, 0);
                                        handleLinkClick();
                                    }} className="text-white transition-all duration-300 hover:text-[#0e4d38] hover:border-b-[3px] hover:border-b-[#0e4d38]"> Career</Link>
                                    {/* <Link to="" onClick={handleLinkClick} className="font-semibold text-black transition-all duration-200 hover:text-yellow-600">
                                       
                                    </Link> */}
                                </div>

                                {/* <Link to="/apply-now"> */}
                                <Link to="https://admission.maya.edu.in/">
                                    <button className='mt-5 md:mt-0 bg-[#0e4d38] px-4 py-2 text-white rounded-full font-semibold transition-all duration-200 hover:bg-gradient-to-br from-yellow-200 via-yellow-300 to-amber-300 hover:text-black'>
                                        Apply Now
                                    </button>
                                </Link>
                            </div>
                        </div>
                    )
                }
            </div>
            <style jsx>{`
                // ...existing styles...
                
                /* Custom scrollbar styles */
                .schools-dropdown-content::-webkit-scrollbar {
                    width: 6px;
                }

                .schools-dropdown-content::-webkit-scrollbar-track {
                    background: transparent;
                }

                .schools-dropdown-content::-webkit-scrollbar-thumb {
                    background-color: #0e4d38;
                    border-radius: 20px;
                }

                /* For Firefox */
                .schools-dropdown-content {
                    scrollbar-width: thin;
                    scrollbar-color:rgb(235, 235, 235) transparent;
                }

                /* Ensure dropdown stays above other content */
                .flowbite-dropdown {
                    z-index: 1000;
                }
            `}</style>
        </div>
    );
};

export default Header;